import { h, Component } from 'preact';
import { HopplerModal, HopplerModalProps } from '../../common/hoppler-modal-component';

interface InquiryDetailsMobileProps extends HopplerModalProps {}
interface InquiryDetailsMobileState {}

export class InquiryDetailsMobile extends HopplerModal<InquiryDetailsMobileProps, InquiryDetailsMobileState> {

  constructor() {
    super();
  }

  doModalClose = () => {}

  render(props:InquiryDetailsMobileProps, state:InquiryDetailsMobileState) {

    return this.modalize(
      <section className="hi-inqpage__details">
        { this.props.children }
      </section>
    )
  }
}